import React, { createContext, useContext, useState } from 'react';

interface MenuStateContextType {
  menuState: boolean;
  setMenuState: React.Dispatch<React.SetStateAction<boolean>>;
}

const MenuStateContext = createContext<MenuStateContextType | undefined>(
  undefined
);

export const useMenuState = (): MenuStateContextType => {
  const context = useContext(MenuStateContext);
  if (!context) {
    throw new Error('useMenuState must be used within a MenuStateProvider');
  }
  return context;
};

interface MenuStateProviderProps {
  children: React.ReactNode;
}

export const MenuStateProvider: React.FC<MenuStateProviderProps> = ({
  children,
}) => {
  const [menuState, setMenuState] = useState<boolean>(false);

  return (
    <MenuStateContext.Provider value={{ menuState, setMenuState }}>
      {children}
    </MenuStateContext.Provider>
  );
};
